import _ from 'lodash/fp'

export const TOOLS_KEYS = [
  "dicomEdit",
  "changePatient",
  "viewStudy",
  "viewerLink",
  "launchInHoros",
  "downloadStudy",
  "downloadCD",
  "attachNonDicom",
  "studyNotes",
  "report",
  "share",
  "markAsRead",
  "dicomRoute",
  "activityLogs",
  "deleteStudy"
]

export const TOOLS_LABELS = _.zipObject(TOOLS_KEYS,[
  "Edit DICOM",
  "Change patient",
  "View on webviewer",
  "Get webviewer link",
  "Launch with Horos",
  "Download images",
  "Download for CD",
  "Attachments",
  "Study notes",
  "Report",
  "Share",
  "Mark as read",
  "Route",
  "See activity logs",
  "Delete"
])

export const TOOLS_ICONS = _.zipObject(TOOLS_KEYS,[
  "edit-line",
  "change-patient",
  "view",
  "link-thin",
  "launch",
  "download",
  "download-cd",
  "attachments",
  "study-notes",
  "report",
  "send-line",
  "unavailable",
  "route",
  "activity-logs", 
  "delete"
])
